window.theme.component('header', el => {
    /**
     * Vars
     */
    const mobileMenuToggler = el.querySelector('.js-mobile-menu-toggler');
    const menuLinks = el.querySelectorAll('.js-nav-item > a');
    const toggleButtons = el.querySelectorAll('.js-mobile-menu-toggler .component-icon');
    const actionLinks = el.querySelectorAll('.action-links.main .component-button');

    /**
     * The scroll lock el.
     *
     * @var {object}
     */
    const scrollLock = {
        isLocked : () => {
            return document.body.classList.contains( 'scroll-lock' );
        },

        lock : () => {
            document.body.classList.add( 'scroll-lock' );
        },

        unlock : () => {
            document.body.classList.remove( 'scroll-lock' );
        }
    };


    /**
     * The list of mega menus.
     *
     * @var {object}
     */
    const megaMenus = [];

    // Add items to the list of mega menus.
    el.querySelectorAll( '.js-nav-item.has-sub-menu, .mobile-nav .js-megamenu-toggle[data-sub-menu-type="megamenu"]' ).forEach( navItem => {
        const index = navItem.dataset.index;
        const type = navItem.dataset.subMenuType;
        let viewport = navItem.dataset.viewport;
        let megaMenuId = navItem.dataset.megamenu;
        let element = el.querySelector(`.js-megamenu[data-megamenu-element="${megaMenuId}"]`);

        if (type === 'dropdown') {
            viewport = 'desktop';
            megaMenuId = index;
            element = el.querySelector(`.js-dropdown[data-index="${index}"]`);
        }

        megaMenus.push({
            index,
            type,
            viewport,
            toggler: navItem,
            element
        });
    });

    /**
     * Remove prevent default from dropdown links
     */
    const dropdownLinks = el.querySelectorAll('.js-dropdown .link');
    dropdownLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });

    /**
     * Opens the specified mega menu.
     *
     * @param {object} megaMenu
     * @param event
     */
    function openMegaMenu( megaMenu, event ) {
        if (event) event.preventDefault();

        el.timeout = setTimeout( () => {
            const actives = megaMenus.filter(menuItem => menuItem.element.classList.contains('active'));
            if (actives.length) {
                let skipOpen = true;

                actives.forEach(menu => {
                    if (megaMenu.element !== menu.element) skipOpen = false;
                    closeMegaMenu(menu);
                });

                if (skipOpen) return;
            }

            el.classList.add( 'active' );
            megaMenu.toggler.classList.add( 'active' );
            megaMenu.element.classList.add( 'active' );
            megaMenu.toggler.setAttribute('aria-expanded', 'true');
            megaMenu.element.removeAttribute('tabindex');

            if (megaMenu.type === 'megamenu') scrollLock.lock();

            //megaMenu.element.querySelector('a:first-child').focus();

            /* Watch escape event */
            document.addEventListener('keydown', mainMenuEscape);

            // Change button/toggle classes
            if(!el.classList.contains('mobile-menu-active')) {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                });

                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', ' light'));
                });
            }
        }, 0 );
    }

    /**
     * Closes the specified mega menu.
     *
     * @param {object} megaMenu
     */
    function closeMegaMenu( megaMenu ) {
        clearTimeout( el.timeout );
        el.classList.remove( 'active' );
        megaMenu.toggler.classList.remove( 'active' );
        megaMenu.element.classList.remove( 'active' );
        megaMenu.toggler.setAttribute('aria-expanded', 'false');
        megaMenu.element.setAttribute('tabindex', '-1');

        if ( scrollLock.isLocked() ) scrollLock.unlock();

        /*  closes the menu and return the focus to the main button */
        megaMenu.toggler.focus();

        /* unwatch escape event */
        document.removeEventListener('keydown', mainMenuEscape);

        // Change button/toggle classes
        if (!el.classList.contains('mobile-menu-active')) {
            toggleButtons.forEach(button => {
                button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
            });

            actionLinks.forEach(button => {
                button.setAttribute('class', button.getAttribute('class').replace(' light', '-light'));
            });
        }
    }

    // Watch for escape key event to close the Mega menu
    function mainMenuEscape(event) {
        const openedMegaMenu = megaMenus.find(menu => menu.element.classList.contains('active'));

        if (openedMegaMenu && (event.key === 'Escape' || event.key === 'Esc')) {
            closeMegaMenu(openedMegaMenu);
        }
    }

    /**
     * Check if item is open
     *
     * @param {element} menuitem
     */
    function isOpen(menuitem) {
        if (!menuitem || !menuitem.getAttribute('aria-expanded')) return false;

        return menuitem.getAttribute('aria-expanded') === 'true';
    }

    /**
     * Add/remove sticky class depending on the scrollY position.
     */
    function toggleSticky() {
        // Make the header sticky.
        el.classList[ window.scrollY > 100 ? 'add' : 'remove' ]( 'sticky' );

        // Change the button based on chosen style.
        if (el.classList.contains('transparent') && !el.classList.contains('mobile-menu-active')) {
            if (window.scrollY > 100) {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
                });

                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', ' light'));
                });
            } else {
                toggleButtons.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                });

                actionLinks.forEach(button => {
                    button.setAttribute('class', button.getAttribute('class').replace(' light', '-light'));
                });
            }
        }
    }

    /**
     * The delay to open the Mega Menu.
     *
     * @var {null|int}
     */
    el.timeout;

    // Setup Mega Menus.
    megaMenus.forEach( megaMenu => {
        const { toggler, viewport, element } = megaMenu;

        // Setup togglers.
        if (viewport === 'desktop') {
            toggler.addEventListener( 'click', event => openMegaMenu( megaMenu, event ) );
            element.addEventListener( 'mouseleave', () => closeMegaMenu( megaMenu ) );
        } else {
            toggler.addEventListener( 'click', () => openMegaMenu( megaMenu ) );

            const closeButton = element.querySelector('.js-close');
            if (closeButton) {
                closeButton.addEventListener( 'click', () => closeMegaMenu( megaMenu ) );
                mobileMenuToggler.addEventListener( 'click', () => closeMegaMenu( megaMenu ) );
            }
        }
    });

    // Open Mobile Menu when its toggler is clicked.
    mobileMenuToggler.addEventListener( 'click', () => {
        el.classList.toggle('mobile-menu-active');
        mobileMenuToggler.setAttribute('aria-expanded', !isOpen(mobileMenuToggler));
        mobileMenuToggler.classList.toggle('active');
        el.querySelector( '.js-mobile-menu' ).classList.toggle('active');
        scrollLock[ mobileMenuToggler.classList.contains('active') ? 'lock' : 'unlock']();

        // Change button/toggle classes
        toggleButtons.forEach(button => {
            if (el.classList.contains('transparent') && !el.classList.contains('sticky')) {
                if (button.classList.contains('style-light')) {
                    button.setAttribute('class', button.getAttribute('class').replace('-light', '-dark'));
                } else {
                    button.setAttribute('class', button.getAttribute('class').replace('-dark', '-light'));
                }
            }
        });
    });

    // Add navigation using arrow keys
    menuLinks.forEach( navItem => {
        navItem.addEventListener('keydown', e => {
            if ( e.key === 'ArrowLeft' || e.keyCode === 37 || e.key === 'ArrowRight' || e.keyCode === 39) {
                const focusedItem = document.activeElement;

                if (focusedItem) {
                    const currentIndex = Array.from(menuLinks).indexOf(focusedItem);

                    /* Replace arrow left behavior to jump to previous item */
                    if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                        if (currentIndex > 0) {
                            menuLinks[currentIndex - 1].focus();
                        }
                    }

                    /* Replace arrow right behavior to jump to next item */
                    if (e.key === 'ArrowRight' || e.keyCode === 39) {
                        if (currentIndex < menuLinks.length - 1) {
                            menuLinks[currentIndex + 1].focus();
                        }
                    }
                }
            }
        });
    });

    // Add event listener to close the menu when it's not focused anymore
    el.addEventListener('focusout', event => {
        setTimeout(() => {
            if (el.contains(event.relatedTarget)) return;

            if (event.toggler && isOpen(event.toggler)) {
                closeMegaMenu(event.toggler);
            }
        }, 100);
    });

    // Close Mobile Menu && check top message height on screen resize when needed.
    window.addEventListener( 'resize', () => {
        if (window.screen.availWidth >= 1200 && mobileMenuToggler.classList.contains( 'active' ) ) {
            mobileMenuToggler.click();
        }
    });

    // Add sticky class on scroll.
    window.addEventListener( 'scroll', () => toggleSticky() );
    toggleSticky();

    // Search
    el.querySelector( '.js-search' ) && el.querySelector( '.js-search' ).addEventListener( 'click', ({ currentTarget }) => {
        const form = el.querySelector( '.js-search-desktop' );

        if ( ! form ) return;

        el.classList.toggle( 'active' );
        form.classList.toggle( 'is-active' );
        currentTarget.classList.toggle( 'is-active' );
    });

    // Mobile Menu Accordion
    const accordion = el.querySelector('.js-accordion');

    /**
     * Close an item.
     *
     * @param {HTMLElement} item
     */
    function closeItem(item) {
        if (!item.classList.contains('is-active')) return;

        item.classList.remove('is-active');
        item.querySelector('.js-item-content').removeAttribute('style');
    }

    /**
     * Open an item.
     *
     * @param {HTMLElement} item
     */
    function openItem(item) {
        if (item.classList.contains('is-active')) return;

        item.classList.add('is-active');

        updateActiveItemHeight();
    }

    /**
     * Update the active item's height.
     *
     */
    function updateActiveItemHeight() {
        const activeItem = el.querySelector('.js-item.is-active');
        if (!activeItem) return;

        const contentHeight = activeItem.querySelector('.js-item-content-wrapper').clientHeight;
        activeItem.querySelector('.js-item-content').style.height = `${contentHeight}px`;
    }

    // Detect clicks on the accordion.
    if (accordion) {
        accordion.addEventListener('click', ({target}) => {
            const toggle = target.closest('.js-item-toggle');
            if (!toggle) return;

            // Get the item this toggle belongs to.
            const item = toggle.parentNode.parentNode;

            // Close the item if it's already active.
            if (item.classList.contains('is-active')) {
                closeItem(item);
            } else {
                // Close the currently active item.
                const activeItem = el.querySelector('.js-item.is-active');
                if (activeItem) closeItem(activeItem);

                // Open the item.
                openItem(item);
            }
        });
    }

    // Update the active item's height when the window is resized.
    let updateTimeout = false;

    window.addEventListener('resize', () => {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => updateActiveItemHeight(), 150);
    });
});